var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlkimaFooterRaketeDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 358,
    viewBox: "0 0 281 358",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152 330H122L130.864 162H143.136L152 330Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.212 80.2292C166.212 124.525 136.607 160.458 136.607 160.458C135.025 158.65 107.001 123.395 107.001 80.2292C107.001 35.9336 120.335 0 136.607 0C153.104 0 166.212 35.9336 166.212 80.2292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.782 170.629H120.334C119.204 170.629 118.526 169.499 118.752 168.595L119.656 164.979L126.21 140.571H147.906L154.46 164.979L155.364 168.595C155.816 169.725 154.912 170.629 153.782 170.629Z",
    fill: "#FC6076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.46 164.979H119.656L126.21 140.345H147.906L154.46 164.979Z",
    fill: "#FC6076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.142 122.492C122.142 122.492 95.0222 134.922 92.5362 181.929C92.3102 184.189 95.7001 184.867 96.3781 182.607C102.028 165.205 115.814 142.154 133.668 142.154L122.142 122.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.82 122.493C122.82 122.493 95.6999 134.923 93.2139 181.93C92.9879 184.19 96.3779 184.868 97.0559 182.608C102.706 165.206 116.492 142.154 134.346 142.154L122.82 122.493Z",
    fill: "#FC6076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.521 122.493C151.521 122.493 178.641 134.923 181.127 181.93C181.353 184.19 177.963 184.868 177.285 182.608C171.635 165.206 157.849 142.154 139.996 142.154L151.521 122.493Z",
    fill: "#FC6076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.89 80.9077C166.89 125.203 137.284 161.137 137.284 161.137C135.702 159.329 107.678 124.073 107.678 80.9077C107.678 36.6122 121.012 0.67855 137.284 0.67855C153.556 0.452553 166.89 36.3862 166.89 80.9077Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.889 80.9077C166.889 125.203 137.284 161.137 137.284 161.137L137.284 0.67855C153.556 0.452553 166.889 36.3862 166.889 80.9077Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.521 54.6918C151.521 63.0537 144.742 69.8336 136.38 69.8336C128.018 69.8336 121.238 63.0537 121.238 54.6918C121.238 46.3299 128.018 39.5499 136.38 39.5499C144.742 39.5499 151.521 46.3299 151.521 54.6918Z",
    fill: "#D12C3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.974 55.1442C151.974 63.5061 145.194 70.286 136.832 70.286C128.47 70.286 121.69 63.5061 121.69 55.1442C121.69 46.7823 128.47 40.0023 136.832 40.0023C145.194 40.0023 151.974 46.7823 151.974 55.1442Z",
    fill: "#FC6076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.865 113.451C138.865 114.807 137.735 115.711 136.605 115.711C135.249 115.711 134.345 114.581 134.345 113.451C134.345 112.096 135.475 111.192 136.605 111.192C137.961 111.192 138.865 112.096 138.865 113.451Z",
    fill: "#3E3E53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.091 113.451C139.091 114.807 137.961 115.711 136.831 115.711C135.475 115.711 134.571 114.581 134.571 113.451C134.571 112.095 135.701 111.191 136.831 111.191C137.961 111.191 139.091 112.095 139.091 113.451Z",
    fill: "#3E3E53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.865 102.151C138.865 103.507 137.735 104.411 136.605 104.411C135.249 104.411 134.345 103.281 134.345 102.151C134.345 100.795 135.475 99.8912 136.605 99.8912C137.961 99.8912 138.865 100.795 138.865 102.151Z",
    fill: "#3E3E53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.091 102.151C139.091 103.507 137.961 104.411 136.831 104.411C135.475 104.411 134.571 103.281 134.571 102.151C134.571 100.795 135.701 99.891 136.831 99.891C137.961 99.891 139.091 101.021 139.091 102.151Z",
    fill: "#3E3E53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.865 90.8513C138.865 92.2073 137.735 93.1113 136.605 93.1113C135.249 93.1113 134.345 91.9813 134.345 90.8513C134.345 89.4953 135.475 88.5913 136.605 88.5913C137.961 88.5913 138.865 89.4953 138.865 90.8513Z",
    fill: "#3E3E53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.091 90.8512C139.091 92.2072 137.961 93.1112 136.831 93.1112C135.475 93.1112 134.571 91.9812 134.571 90.8512C134.571 89.4952 135.701 88.5912 136.831 88.5912C137.961 88.5912 139.091 89.7212 139.091 90.8512Z",
    fill: "#3E3E53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.488 55.1442C149.488 62.1502 143.838 67.5741 137.058 67.5741C130.052 67.5741 124.628 61.9242 124.628 55.1442C124.628 48.3643 130.278 42.7144 137.058 42.7144C143.838 42.7144 149.488 48.1383 149.488 55.1442Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.74 49.2683C143.158 47.9123 141.125 47.2343 138.865 47.2343C133.441 47.2343 128.921 51.7543 128.921 57.1782C128.921 59.4382 129.599 61.4722 130.955 63.2801C128.469 61.4722 126.887 58.5342 126.887 55.3702C126.887 49.9463 131.407 45.4263 136.831 45.4263C140.221 45.2003 142.932 46.7823 144.74 49.2683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 292,
    r: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 324,
    r: 13,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 320,
    r: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 306.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 326.5,
    r: 2.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 305,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.5,
    cy: 340.5,
    r: 24.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 322.5,
    r: 21.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 343,
    r: 19,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187,
    cy: 350,
    r: 19,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.5,
    cy: 357.5,
    r: 16.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.5,
    cy: 347.5,
    r: 17.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 327,
    r: 26,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 286.5,
    r: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 337.5,
    r: 15.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 314,
    r: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 348.5,
    r: 20.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 350.5,
    r: 20.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 357.5,
    r: 20.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 345.5,
    r: 32.5,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 166.89,
    y1: 161.137,
    x2: 95.1396,
    y2: 155.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 166.889,
    y1: 161.137,
    x2: 130.838,
    y2: 159.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 281,
    height: 358,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlkimaFooterRaketeDesktop);
export default __webpack_public_path__ + "static/media/alkima-footer-rakete-desktop.7ee12a9468e04e0bde284d841471d617.svg";
export { ForwardRef as ReactComponent };